import { AssetsExplorerModel } from 'Roblox';
import assetsExplorerModule from '../assetsExplorerModule';

function assetsExplorerController($scope, assetsMessageService, assetsConstants, assetsService) {
  'ngInject';

  const ctrl = this;

  const layoutData = { ...assetsConstants.defaultLayoutData };

  ctrl.makeUrlFriendly = assetsService.makeUrlFriendly;

  ctrl.shouldShowPremiumIcon = item => {
    if (!layoutData.isPremiumIconOnItemTilesEnabled) {
      return false;
    }

    if (!item.Product || !item.Product.PremiumPriceInRobux) {
      return false;
    }

    return true;
  };

  ctrl.getDisplayPrice = item => {
    if (!item.Product) {
      return undefined;
    }

    if (layoutData.isPremiumPriceOnItemTilesEnabled && item.Product.PremiumPriceInRobux) {
      return item.Product.PremiumPriceInRobux;
    }

    return item.Product.PriceInRobux;
  };

  ctrl.doesItemHavePrice = item => {
    if (!item.Product) {
      return false;
    }

    if (
      !item.Product.PriceInRobux &&
      (!item.Product.PremiumPriceInRobux || !layoutData.isPremiumPriceOnItemTilesEnabled)
    ) {
      return false;
    }

    return true;
  };

  const init = () => {
    $scope.assetsPager = ctrl.assetsPager;
    ctrl.staticData = AssetsExplorerModel;
    ctrl.assetsConstants = assetsConstants;
    ctrl.getInventoryEmptyMessage = assetsMessageService.getInventoryEmptyMessage;
    ctrl.getInventoryNewItemsMessage = assetsMessageService.getInventoryNewItemsMessage;
    ctrl.showMessageToFindNewItems = assetsMessageService.showMessageToFindNewItems;
    ctrl.getExploreMessage = assetsMessageService.getExploreMessage;

    assetsService.getCatalogMetadata().then(function success(result) {
      const { isPremiumIconOnItemTilesEnabled, isPremiumPriceOnItemTilesEnabled } = result;

      layoutData.isPremiumIconOnItemTilesEnabled = isPremiumIconOnItemTilesEnabled;
      layoutData.isPremiumPriceOnItemTilesEnabled = isPremiumPriceOnItemTilesEnabled;
    });
  };

  ctrl.$onInit = init;
}

assetsExplorerModule.controller('assetsExplorerController', assetsExplorerController);
export default assetsExplorerController;
